import React from 'react'
import { WithContext as ReactTags } from 'react-tag-input'
import ObjectUtil from '@leverege/object-util'

export default class Tags extends React.Component {

  render() {
    const { tags = [], suggestions, placeholder, tagAdded, tagRemoved } = this.props
    // const tags = this.props.tags || [];
    const uitags = [];
    if ( tags ) {
      for ( let n = 0; n < tags.length; n++ ) {
        if ( typeof tags[n] === 'object' && tags[n] != null ) {
          uitags.push( tags[n] )
        } else {
          uitags.push( { id : tags[n], text : tags[n] } );
        }
      }
    }

    const sug = suggestions && suggestions.map( ( suggestion, index ) => ( { id : suggestion, text : suggestion } ) )
    
    return (
      <ReactTags tags={uitags}
        autofocus={false}
        suggestions={sug}
        placeholder={placeholder}
        handleAddition={( e ) => { 
          const arr = ObjectUtil.copy( tags );
          if ( tags.indexOf( e ) < 0 ) {
            arr.push( e.text );
            if ( tagAdded ) {
              tagAdded( e, arr )
            }
          } 
        }}
        handleDelete={( index ) => { 
          const arr = ObjectUtil.copy( tags );
          if ( index >= 0 ) {
            const e = arr[index]
            arr.splice( index, 1 );
            if ( tagRemoved ) {
              tagRemoved( e, arr )
            }
          }
        }} />
    )
  }
}
